import { useLastPathSegment } from 'shared/hooks'
import { useInternationalStepsContext } from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'
import { type InternationalRoutes } from '../route/type'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useInternationalStepsContext()

  return getProgressInfoTitle(useLastPathSegment() as InternationalRoutes)
}
